
export const MODULE_NAME = 'lk-roadmaps-feed'

export const LK_ROADMAPS_FEED_ROUTES = {
  LAYOUT: MODULE_NAME,
  LIST: `${MODULE_NAME}.list`,
  VIEW: `${MODULE_NAME}.view`,
} as const
